import { render, staticRenderFns } from "./WordCloudContent.vue?vue&type=template&id=744044be&scoped=true&"
import script from "./WordCloudContent.vue?vue&type=script&lang=js&"
export * from "./WordCloudContent.vue?vue&type=script&lang=js&"
import style0 from "./WordCloudContent.vue?vue&type=style&index=0&id=744044be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744044be",
  null
  
)

export default component.exports